import React from 'react'
import { normalizeProps } from './utils/normalizeProps'

const MinimizeIcon = ({ inverted, ...props}) => {
  const transformStyle = inverted ? { transform: 'rotate(0deg)' } : {}
  return (
    <svg
      width='22'
      height='19'
      viewBox='0 0 22 19'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={transformStyle}
      {...normalizeProps(props)}
    >
      <path
        d='M10.0833 10.3998L6.79952 10.3998L7.98468 11.5632C8.34266 11.9145 8.34266 12.4843 7.98468 12.8357C7.6267 13.187 7.04629 13.187 6.68831 12.8357L3.93831 10.1363C3.58033 9.78488 3.58033 9.21516 3.93831 8.86377L6.68831 6.16439C7.04629 5.813 7.6267 5.813 7.98468 6.16439C8.34266 6.51578 8.34266 7.0855 7.98468 7.43689L6.79953 8.60023L10.0833 8.60023C10.5896 8.60023 11 9.00308 11 9.50002C11 9.99696 10.5896 10.3998 10.0833 10.3998Z'
        fill='white'
      />
      <path
        d='M22 14.9008C22 16.8886 20.3584 18.5 18.3333 18.5L3.66667 18.5C1.64162 18.5 -1.40874e-07 16.8886 -3.1465e-07 14.9008L6.48389e-07 4.09918C4.74612e-07 2.11141 1.64162 0.500002 3.66667 0.500002L18.3333 0.500002C20.3584 0.500002 22 2.11141 22 4.09918L22 14.9008ZM3.66667 16.7004L12.8344 16.7004L12.8344 2.29959L3.66667 2.29959C2.65415 2.29959 1.83333 3.10529 1.83333 4.09918L1.83333 14.9008C1.83333 15.8947 2.65414 16.7004 3.66667 16.7004Z'
        fill='white'
      />
    </svg>
  )
}

export default MinimizeIcon
